import { DatePicker, Modal } from "antd";
import localeEN from "antd/es/date-picker/locale/en_US";
import localeTR from "antd/es/date-picker/locale/tr_TR";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { getActiveLanguage } from "react-localize-redux";
import { connect } from "react-redux";
import ArrowDownIcon from "../../../../assets/icons/ArrowDownIcon.jsx";
import CalendarIcon from "../../../../assets/icons/CalendarIcon.jsx";
import ModalCloseIcon from "../../../../assets/icons/ModalCloseIcon.jsx";
import { Date, DatePickerButtonWrapper, DatePickerWrapper } from "./elements.js";
import "./rangePicker.sass";

const HistoryRangePicker = ({ translate, onChange, currentLanguage }) => {
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [dates, setDates] = useState([moment().subtract(1, "months"), moment()]);
	const [picker, setPicker] = useState(null);

	const locales = {
		"en": localeEN,
		"tr": localeTR,
	};

	const handleOpenChange = (picker) => {
		setPicker(picker);
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
		setPicker(null);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		setPicker(null);
	};

	const handleRangeChange = (date, picker) => {
		if (picker === "start") {
			setDates([date, dates[1]]);
			setPicker("end");
		} else {
			setDates([dates[0], date]);
			setIsModalVisible(false);
			setPicker(null);
		}
		if (onChange) {
			onChange([dates[0], date]);
		}
	};

	useEffect(() => {
		if (!isModalVisible) {
			const pickerPanel = document.querySelector(".ant-picker-dropdown");
			if (pickerPanel) pickerPanel.style.display = "none";
		}

		return () => {
			const pickerPanel = document.querySelector(".ant-picker-dropdown");
			if (pickerPanel) pickerPanel.style.display = "block";
		};
	}, [isModalVisible]);

	const dateRender = (current) => {
		let coloredRange = "";
		if (current?.isBetween(dates[0], dates[1])) {
			coloredRange = "selected-range";
		}
		return (
			<div className={`ant-picker-cell-inner ${picker} ${coloredRange}`}>
				{current.date()}
			</div>
		);
	};

	const handleSelect = (date) => {
		if (picker === "start" && dates[0].isSame(date, "day")) {
			setIsModalVisible(false);
			setPicker(null);
		} else if (picker === "end" && dates[1].isSame(date, "day")) {
			setIsModalVisible(false);
			setPicker(null);
		}
	};

	return (
		<DatePickerWrapper className="date-picker-wrapper">
			<DatePickerButtonWrapper>
				<CalendarIcon />
				<Date onClick={() => handleOpenChange("start")}>{dates[0].format("DD/MM/YY")}</Date>
				-<Date onClick={() => handleOpenChange("end")}>{dates[1].format("DD/MM/YY")}</Date>
				<ArrowDownIcon />
			</DatePickerButtonWrapper>
			<Modal
				visible={isModalVisible}
				onOk={handleOk}
				footer={null}>
				{picker === "start" && (
					<DatePicker
						className="hidden-input"
						value={dates[0]}
						format={"DD/MM/YY"}
						open={isModalVisible}
						onChange={(date) => {
							handleRangeChange(date, "start");
						}}
						renderExtraFooter={() => <div>{translate("Start")}</div>}
						locale={locales[currentLanguage]}
						dateRender={dateRender}
						onSelect={handleSelect}
					/>
				)}
				{picker === "end" && (
					<DatePicker
						className="hidden-input"
						format={"DD/MM/YY"}
						value={dates[1]}
						open={isModalVisible}
						onChange={(date) => {
							handleRangeChange(date, "end");
						}}
						renderExtraFooter={() => <div>{translate("End")}</div>}
						locale={locales[currentLanguage]}
						dateRender={dateRender}
						onSelect={handleSelect}
					/>
				)}
				<ModalCloseIcon onClick={handleCancel} />
			</Modal>
		</DatePickerWrapper>
	);
};

const mapStateToProps = (state) => {
	return {
		currentLanguage: getActiveLanguage(state.localize).code,
	};
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryRangePicker);
